import {
  docCollectorFinished,
  getPaymentId,
  getPaymentStatus,
  getRecipientId,
  isCAP,
  requiresDocuments,
} from 'selectors';
import { files } from 'services/files/files';
import {
  PAYMENT_STATUS_DELIVERED,
  RECIPIENTS_WITH_GUARANTEED_TO_DELIVERED_STATUS,
} from '../../../constants';

export const getLinkById = (state, id) => {
  const {
    entities: { links },
  } = state;

  return links[id] || null;
};

export const getManagementLinks = state => {
  const {
    entities: { links },
  } = state;

  const initiate = getInitiateLink(state, links);
  const cancellation = getLinkById(state, 'cancellation');
  const smsNotification = getSmsNotificationLink(state, links);

  const managementLinks = {};
  if (initiate) {
    managementLinks.initiate = initiate;
  }
  if (cancellation) {
    managementLinks.cancellation = cancellation;
  }
  if (smsNotification) {
    managementLinks.sms_notification = smsNotification;
  }
  managementLinks.receipt = getReceiptLink(state, links);

  return managementLinks;
};

const getInitiateLink = (state, links) => {
  const { initiate = null } = links;

  if (requiresDocuments(state) && !docCollectorFinished(state)) {
    return;
  }

  return initiate;
};

const getSmsNotificationLink = (state, links) => {
  if (!links.sms_notification) {
    return;
  }
  if (isCAP(state)) {
    return;
  }

  return links.sms_notification;
};

const getReceiptLink = (state, _links) => {
  const receipt = getLinkById(state, 'receipt');

  if (receipt) {
    return receipt;
  }

  const recipientId = getRecipientId(state);
  const isRecipientInGuaranteedToDeliveredExperiment =
    RECIPIENTS_WITH_GUARANTEED_TO_DELIVERED_STATUS.includes(recipientId);
  const paymentStatus = getPaymentStatus(state);
  const isDeliveredPayment = paymentStatus === PAYMENT_STATUS_DELIVERED;

  if (isRecipientInGuaranteedToDeliveredExperiment && isDeliveredPayment) {
    const paymentReference = getPaymentId(state);

    return {
      href: files.getReceiptUrl(paymentReference),
      rel: 'receipt',
      method: 'GET',
    };
  }
};

export const getLinks = state => {
  const {
    entities: { links },
  } = state;

  return links;
};
